import { listado } from "./listado";

function listar(params) {
  return listado("ofertas/listar", params);
}
export default { listar };
